angular.module('storage', [])
    .factory('storageFactory', storageFactory);

storageFactory.$inject = ['encryptionFactory'];
function storageFactory(encryptionFactory) {
    var service = {
        savedUser: {
            get: getSavedUser,
            set: saveUser,
            delete: deleteUser
        },
        userToken: {
            get: getUserToken,
            set: saveUserToken,
            delete: deleteUserToken
        },
        reservations: {
            get: getReservations,
            set: saveReservations,
            delete: deleteReservations
        },
        keys: {
            get: getKeys,
            set: saveKeys,
            delete: deleteKeys
        },
        properties: {
            get: getProperties,
            set: saveProperties,
            delete: deleteProperties
        },
        savedUnitReportGroups: {
            get: getUnitReportGroups,
            set: saveUnitReportGroups,
            delete: deleteUnitReportGroups
        },
        lastSynced: {
            get: getLastSynced,
            set: saveLastSynced,
            delete: deleteLastSynced
        },
        selectedProperty: {
            get: getSelectedProperty,
            set: saveSelectedProperty,
            delete: deleteSelectedProperty
        }
    };
    return service;

    ////////////////////////////////////////////////////////////////////////////////

    // SETTERS

    function saveUser(user) {
        localStorage.setItem('user', JSON.stringify(user));
    }

    function saveUserToken(token, pin) {
        var encryptedToken = encryptionFactory.encrypt(token, pin);
        var key = 'token';
        localStorage.setItem(key, encryptedToken);
    }

    function saveReservations(reservations, pin) {
        var encryptedReservations = encryptionFactory.encrypt(reservations, pin);
        localStorage.setItem('reservations', encryptedReservations);
    }

    function saveKeys(keys, pin) {
        var encryptedKeys = encryptionFactory.encrypt(keys, pin);
        localStorage.setItem('keys', encryptedKeys);
    }

    function saveProperties(properties, pin) {
        var encryptedProperties = encryptionFactory.encrypt(properties, pin);
        localStorage.setItem('properties', encryptedProperties);
    }

    function saveUnitReportGroups(unitReportGroups, pin){
        var encryptedUnitReportGroups = encryptionFactory.encrypt(unitReportGroups, pin);
        localStorage.setItem('unitReportGroups', encryptedUnitReportGroups);
    }

    function saveLastSynced(lastSynced, pin){
        var encryptedLastSynced = encryptionFactory.encrypt(lastSynced, pin);
        localStorage.setItem('lastSynced', encryptedLastSynced);
    }

    function saveSelectedProperty(selectedProperty, pin){
        var encryptedSelectedProperty = encryptionFactory.encrypt(selectedProperty, pin);
        localStorage.setItem('selectedProperty', encryptedSelectedProperty);
    }

    // GETTERS

    function getSavedUser() {
        return JSON.parse(localStorage.getItem('user'));
    }

    function getUserToken(pin) {
        var key = 'token';
        var encryptedToken = localStorage.getItem(key);
        var decryptedToken = encryptionFactory.decrypt(encryptedToken, pin);
        return decryptedToken;
    }

    function getReservations(pin) {
        var encryptedReservations = localStorage.getItem('reservations');
        var decryptedReservations = encryptionFactory.decrypt(encryptedReservations, pin);
        return decryptedReservations;
    }

    function getKeys(pin) {
        var encryptedKeys = localStorage.getItem('keys');
        var decryptedKeys = encryptionFactory.decrypt(encryptedKeys, pin);
        return decryptedKeys;
    }

    function getProperties(pin) {
        var encryptedProperties = localStorage.getItem('properties');
        var decryptedProperties = encryptionFactory.decrypt(encryptedProperties, pin);
        return decryptedProperties;
    }

    function getUnitReportGroups(pin) {
        var encryptedUnitReportGroups = localStorage.getItem('unitReportGroups');
        var decryptedUnitReportGroups = encryptionFactory.decrypt(encryptedUnitReportGroups, pin);
        return decryptedUnitReportGroups;
    }

    function getLastSynced(pin) {
        var encryptedLastSynced = localStorage.getItem('lastSynced');
        var decryptedLastSynced = encryptionFactory.decrypt(encryptedLastSynced, pin);
        return decryptedLastSynced;
    }

    function getSelectedProperty(pin) {
        var encryptedSelectedProperty = localStorage.getItem('selectedProperty');
        var decryptedSelectedProperty = encryptionFactory.decrypt(encryptedSelectedProperty, pin);
        return decryptedSelectedProperty;
    }

    // DELETERS

    function deleteUser(){
        localStorage.removeItem('user');
    }

    function deleteUserToken(){
        localStorage.removeItem('token');
    }

    function deleteReservations(){
        localStorage.removeItem('reservations');
    }

    function deleteKeys(){
        localStorage.removeItem('keys');
    }

    function deleteProperties(){
        localStorage.removeItem('properties');
    }

    function deleteUnitReportGroups() {
        localStorage.removeItem('unitReportGroups');
    }

    function deleteLastSynced() {
        localStorage.removeItem('lastSynced');
    }

    function deleteSelectedProperty() {
        localStorage.removeItem('selectedProperty');
    }

}
